import { Tooltip } from '@mui/material';
import React from 'react';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';

import { PickerTargetButton } from '../../../../../containers/mask-overlays/mask-overlay/views/components/table-cells/PickerTargetButton';

import {
  SupplierPricePicker,
  SupplierPricePickerProps,
} from './SupplierPricePicker';

interface Props extends Omit<SupplierPricePickerProps, 'multiple'> {
  label?: string;
  error?: string;
  disabled?: boolean;
}

export const SupplierPricePickerField = React.forwardRef<HTMLDivElement, Props>(
  (props, _ref) => {
    const { ...pickerProps } = props;
    const { value } = pickerProps;

    return (
      <EntityPickerPopover
        width={800}
        picker={<SupplierPricePicker {...pickerProps} />}
      >
        <Tooltip title={value?.name} enterDelay={300}>
          <PickerTargetButton
            hover
            style={{
              margin: '-0.25rem 0 0 0',
            }}
            value={value?.name || ''}
            disabled={pickerProps.disabled}
          >
            {value?.name}
          </PickerTargetButton>
        </Tooltip>
      </EntityPickerPopover>
    );
  }
);
